export default __webpack_public_path__ + "static/media/combination.6a5e8c75.svg";